import React, { useContext, useEffect, useState } from 'react';
import { Modal } from 'antd';
import { useRouter } from 'next/router';
import { IOnboardingDataType, IOnboardingStep, OnboardingData } from '@/utils/onboarding/OnboardingData';
import { useList } from '@refinedev/core';
import { OnboardingContext } from '@/utils/context/Onboarding/OnboardingContext';
import { CloseOutlined } from '@ant-design/icons';
import { CommonContentContext } from '@/utils/context/commonContent/CommonContentContext';

const OnboardingModal = () => {
  const router = useRouter();
  const { showOnboardingProcess, setShowOnboardingProcess, finishedOnboarding, setFinishedOnboarding } =
    useContext(OnboardingContext);
  const [stepData, setStepData] = useState<IOnboardingStep>(OnboardingData.home);

  const { data } = useList({ resource: stepData.resource });
  const currentPath = router.pathname;

  const handleNextStepBtn = () => {
    router.push(stepData.nextRoute);
  };
  const handleCloseBtn = () => {
    setShowOnboardingProcess(false);
  };
  useEffect(() => {
    stepData.nextRoute === '/' && !finishedOnboarding ? setFinishedOnboarding(true) : setFinishedOnboarding(false);
    const currentPaths = currentPath.split('/')[1];
    const pageInfo: IOnboardingStep = Object.values(OnboardingData).find(
      (step) => step.route.split('/')[1] === currentPaths
    );

    pageInfo && setStepData(pageInfo);
  }, [currentPath]);

  return (
    <div data-cy="onboarding-modal">
      <Modal
        open={showOnboardingProcess}
        onCancel={handleCloseBtn}
        maskClosable={true}
        closeIcon={
          <button
            onClick={handleCloseBtn}
            className="hover:bg-primary-light rounded bg-primary px-2 font-bold text-white"
          >
            <CloseOutlined />
          </button>
        }
        footer={
          <div>
            {' '}
            <button
              className="hover:bg-primary-light rounded bg-primary px-4 py-2 font-bold text-white"
              onClick={handleCloseBtn}
            >
              Close
            </button>{' '}
            <button
              className="hover:bg-primary-light rounded bg-primary px-4 py-2 font-bold text-white"
              onClick={handleNextStepBtn}
            >
              Next Step
            </button>{' '}
          </div>
        }
      >
        <h4 className="text-center text-xl font-bold uppercase text-primary">{stepData.title}</h4>
        {(data && data.total > 0) || finishedOnboarding ? (
          <p className="text-lg">{stepData.completedMessage}</p>
        ) : (
          <p className="text-lg">{stepData.message}</p>
        )}
      </Modal>
    </div>
  );
};

export default OnboardingModal;
